import { alpha, useTheme } from '@mui/material';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { IMPORT_MODAL_DEFAULTS, importModalAtom } from '@/atoms/import';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { Text } from '@/components/ui/text';
import { paths } from '@/constants';
import { episodeImportLoader } from '@/enums';
import { usePrefValue } from '@/preferences';
import { ImportLoader, ImportLoaderWrap, ImportSuccess } from './ImportScript.styles';

export const ImportScriptLoader = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [importModal, setImportModal] = useAtom(importModalAtom);
    const navigate = useNavigate();
    const side_bar = usePrefValue('side_bar');
    const loader = importModal.loader;

    const handleFinish = () => {
        setImportModal(() => IMPORT_MODAL_DEFAULTS);
    };

    return (
        <ImportLoader open={Boolean(loader)}>
            {loader === episodeImportLoader.done ? (
                <ImportSuccess>
                    <Text variant="subtitle4" children={t('import.success')} className="font-normal" />
                    <div className="grid gap-[16px]">
                        <Button
                            variant="contained"
                            onClick={() => {
                                navigate(paths.project.scene.editor);
                                handleFinish();
                            }}
                            children={t('scene.go-to-scenario')}
                        />
                        <Button variant="outlined" onClick={handleFinish} children={t('close')} />
                    </div>
                </ImportSuccess>
            ) : (
                <ImportLoaderWrap sideBar={side_bar}>
                    <div className="flex">
                        <Spinner size={92} className="[&_circle]:[stroke:url(#my_gradient)]" />
                        <svg width={0} height={0}>
                            <defs>
                                <linearGradient id="my_gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" stopColor={theme.palette.secondary.main} />
                                    <stop offset="100%" stopColor={alpha(theme.palette.secondary.main, 0.5)} />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>

                    {Boolean(loader) && (
                        <Text
                            variant="subtitle4"
                            children={t(`import.loader.${loader}`)}
                            className="max-w-[400px] font-normal text-center"
                        />
                    )}
                </ImportLoaderWrap>
            )}
        </ImportLoader>
    );
};
